import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addSpaces',
  standalone: true
})
export class AddSpacesPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';
    return value.replace(/([a-z])([A-Z])/g, '$1 $2')
  }
}
